import type { FareDetailErrorType } from '@/api';
import cabErrorImage from '@/assets/api-error.png?url';
import cabExclamImage from '@/assets/api-warning.png?url';
import { NoServicable, SearchError } from '@/components/icons';
import { ErrorLayout, type ErrorLayoutProps } from './Layout';

interface FareDetailErrorMap
	extends Record<
		FareDetailErrorType,
		{ image: React.ReactNode; btnText: string }
	> {}
export interface FareDetailViewProps
	extends Omit<ErrorLayoutProps, 'buttonText'> {
	errorType: FareDetailErrorType;
	onAction?: () => void;
	errorMap: FareDetailErrorMap;
}

export const FARE_DETAIL_ERROR_MAP: FareDetailErrorMap = {
	NOT_SERVICEABLE: {
		image: <NoServicable />,
		btnText: 'Change Location',
	},
	AIRPORT_ONLY: {
		image: cabExclamImage,
		btnText: 'Change Location',
	},
	NO_CABS: {
		image: <SearchError />,
		btnText: 'Modify Search',
	},
	GENERIC_ERROR: {
		image: cabErrorImage,
		btnText: 'Go to Home',
	},
};

export const FareDetailView = ({
	title,
	description,
	errorType = 'GENERIC_ERROR',
	onAction,
	fullScreen = true,
	errorMap,
	...restprops
}: FareDetailViewProps) => {
	if (!errorMap[errorType]) {
		errorType = 'GENERIC_ERROR';
		title = "Sorry! We couldn't fetch the cab details.";
		description = 'Please refresh the page or try searching a cab again.';
	}
	const { image, btnText } = errorMap[errorType];
	return (
		<ErrorLayout
			title={title}
			description={description}
			buttonText={btnText}
			buttonProps={{
				onClick: onAction,
			}}
			fullScreen={fullScreen}
			{...restprops}
		>
			<div className="flex justify-center items-center">
				{typeof image === 'string' ? (
					<img src={image} alt="Error" className="size-100 object-contain" />
				) : (
					<div className="size-100 flex items-center justify-center">
						{image}
					</div>
				)}
			</div>
		</ErrorLayout>
	);
};
